import React, { useState, useEffect, useCallback } from "react";
import {
  ShepPagination,
  ShepDataGridPro,
} from "@/components/GenericComponents/ShepComponents";
import CustomDatePicker from "@/components/CustomDatePicker/CustomDatePicker";
import { createAlert } from "@/features/homepage/alertSliceList";
import { useSelector, useDispatch } from "react-redux";
import axios from "@/features/axiosHelper";
import dayjs from "dayjs";
import {
  selectDateFilter,
  selectMessageFilterSender,
} from "@/features/homepage/homeSlice";
import { FilterDropDownType } from "@/utils/utils";
import CustomFilterDropdown from "@/components/CustomFilterDropdown/CustomFilterDropdown";
import {
  Container,
  Stack,
  Typography,
  Box,
  TextField,
  Button,
  InputAdornment,
} from "@mui/material";
import {
  MessageArchiveHover,
  MessageArchive,
  PinHover,
  PinInactive,
  markAsRead,
  MarkAsReadHover,
  MessagesOpen,
  PDFDownload,
  PDFDownloadFilled,
  SearchIcon,
} from "../../../ImageRepo";
import { selectCustomerFilterConnections } from "../../../features/connectionsBar/connectionsBarSlice";
import {
  selectMessageFilterType,
  selectMessageFilterRead,
  selectMessageFilterUnread,
  selectMessageFilterPinned,
  setMessageFilterSender,
  setMessageFilterType,
  setMessageFilterRead,
  setMessageFilterUnread,
} from "@/features/homepage/homeSlice";
import {
  selectMessagesDateFilter,
  loadDateFilter,
  setMessagesDateFilter,
} from "@/features/dateFilterSlice";
import ShepCheckbox from "@/components/GenericComponents/ShepCheckbox";
import ShepTooltip from "@/components/GenericComponents/ShepTooltip";
import Divider from "@mui/material/Divider";
import "./MessageContent.css";
import _ from "lodash";
import { Start } from "@mui/icons-material";

const messagesDateFilterKey = "MessagesDateFilter"; //key which maps to the user preference value

const recordStatuses = {
  unAchive: 1,
  unRead: 2,
  read: 3,
  archive: 4,
  pin: 5,
  unPin: 6,
};

const max_pin = 15;
const dataGridSx = {
  maxHeight: 600,
  width: "600px",
  "& .MuiDataGrid-columnSeparator": {
    display: "none",
  },
  "& .MuiDataGrid-row:hover .item-tools": {
    display: "inline",
  },
  "& .MuiDataGrid-row .item-tools": {
    display: "none",
  },
  "& .MuiDataGrid-columnHeaders.MuiDataGrid-withBorderColor": {
    display: "none",
  },
  "& .MuiDataGrid-columnHeaderTitleContainer, & MuiDataGrid-columnHeaderDraggableContainer":
    {
      display: "none",
    },
  "& .MuiDataGrid-virtualScroller": {
    overflowX: "hidden",
  },
  "&, [class^=MuiDataGrid]": { border: "none" },
  "& .MuiDataGrid-row": {
    borderTopLeftRadius: "4px",
    borderBottomLeftRadius: "4px",
    borderLeft: "8px solid transparent",
    backgroundColor: "transparent",
  },
  "& .MuiDataGrid-row.Mui-selected": {
    borderLeft: "8px solid var(--primary-main)",
    backgroundColor: "var(--tertiary-14)",
  },

  "& .MuiDataGrid-row:hover .Receive-date": {
    display: "none",
  },
  "& .MuiDataGrid-cellCheckbox": {
    paddingTop: "10px",

    borderBottom: "1.5px solid var(--grey-lowlight)",
  },

  "& .MuiDataGrid-selectedRowCount": {
    display: "none",
  },
  "& .MuiDataGrid-row .Receive-date": {
    display: "inline",
  },
  "& .MuiDataGrid-row:hover": {
    backgroundColor: "var(--tertiary-13)",
  },
  "& .message-content-popup.MuiDataGrid-cell": {
    outline: "none",
  },
  "& .message-content-popup.MuiDataGrid-cell:hover": {
    outline: "none",
  },
  "& .workflow-row:hover": {
    backgroundColor: "transparent",
  },
  "& .Mui-selected, & .MuiDataGrid-row.Mui-selected  ": {
    backgroundColor: "transparent",
  },
  "& .MuiDataGrid-cell:focus, & .MuiDataGrid-cell:focus-within, & .MuiDataGrid-columnHeader:focus":
    {
      outline: "none",
    },
  "& .MuiDataGrid-footerContainer.MuiDataGrid-withBorderColor .MuiBox-root .MuiStack-root .MuiTypography-root.MuiTypography-body1":
    {
      fontSize: "12px",
    },
};

const typeOptions = [
  { key: "18640", label: "Text Message (EDI 864)", isChecked: false },
  { key: "18240", label: "Application Advice (EDI 824)", isChecked: false },
  {
    key: "18520",
    label: "Product Activity Data report (EDI 852)",
    isChecked: false,
  },
  {
    key: "18120",
    label: "Credit/Debit Adjustment (EDI 812)",
    isChecked: false,
  },
  {
    key: "18200",
    label: "Payment Order or Remittance (EDI 820)",
    isChecked: false,
  },
  {
    key: "18160",
    label: "Organizational Relationships (EDI 816)",
    isChecked: false,
  },
];

const FlipingImageButton = (props) => {
  const [mouseIn, setMouseIn] = useState(false);
  const onMouseEnter = () => setMouseIn(true);
  const onMouseLeave = () => setMouseIn(false);
  const onClick = (event, data) => {
    if (props.onClick && props.onClick && typeof props.onClick === "function") {
      props.onClick(event, data);
      event.stopPropagation();
    }
  };
  const getSrc = () => {
    if (mouseIn && props.hoverSrc) return props.hoverSrc;
    return props.src;
  };
  return (
    <ShepTooltip title={props.tooltip} open={mouseIn}>
      <img
        className={props.className}
        style={props.style}
        src={getSrc()}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
        onClick={onClick}
        height={props.height ?? 18}
      />
    </ShepTooltip>
  );
};

const MessageContent = (props) => {
  const dispatch = useDispatch();
  const [isInitialMessagesLoad, setIsInitialMessagesLoad] = useState(true);
  const [selectedModel, setSelectedModel] = useState([]);
  const [fileContent, setFileContent] = useState("");
  const [currentSelectedId, setCurrentSelectedId] = useState("");
  const [selectedPinnedModel, setSelectedPinnedModel] = useState([]);
  const [referenceFilter, setReferenceFilter] = useState("");
  const [rows, setRows] = useState([]);
  const [selectedMessage, setSelectedMessage] = useState({});
  const [currentLoadedId, setCurrentLoadedId] = useState("");
  const [isDataLoaded, setIsDataLoaded] = useState(false);
  const { startDate, endDate, source } =
      useSelector(selectMessagesDateFilter) || {};
  const [dates, setDates] = useState([
    startDate || dayjs().subtract(7, "day").startOf("day"),
    endDate || dayjs().add(1, "day").startOf("day").subtract(1, "minute"),
  ]);

  const connections = useSelector(selectCustomerFilterConnections);
  const typeFilter = useSelector(selectMessageFilterType);
  const senderFilter = useSelector(selectMessageFilterSender);
  const readFilter = useSelector(selectMessageFilterRead);
  const unreadFilter = useSelector(selectMessageFilterUnread);
  const pinnedFilter = useSelector(selectMessageFilterPinned);

  // Load preferred start date once
  useEffect(() => {
    dispatch(
      loadDateFilter({ area: "messages",preferenceKey: messagesDateFilterKey })
    );
    prepFilters();
  }, [dispatch]);

  // Sync local dates for the date picker when redux updates
    useEffect(() => {
      if (startDate && endDate) {
        setDates([startDate, endDate]);
      }
    }, [startDate, endDate]);
  
  
  const archive = props.isArchive ?? false;

  useEffect(() => {
    let selected = "";
    if (selectedModel && selectedModel.length) {
      selected = selectedModel[0];
      selectedPinnedModel &&
        selectedPinnedModel.length &&
        setSelectedPinnedModel([]);
    }
    if (selected) {
      loadFileContent(selected);
    } else if (!isInitialMessagesLoad) {
      clearFileContent();
    }
  }, [selectedModel]);

  const clearFileContent = () => {
    if (
      (!selectedPinnedModel || selectedPinnedModel.length === 0) &&
      (!selectedModel || selectedModel.length === 0)
    ) {
      setSelectedMessage(null);
      setCurrentSelectedId("");
      setFileContent("");
    }
  };

  useEffect(() => {
    let selected = "";
    if (selectedPinnedModel && selectedPinnedModel.length) {
      selected = selectedPinnedModel[0];
      selectedModel && selectedModel.length && setSelectedModel([]);
    }
    if (selected) {
      loadFileContent(selected);
    } else if (!isInitialMessagesLoad) {
      clearFileContent();
    }
  }, [selectedPinnedModel]);

  const columns = [
    {
      field: "id",
      resizable: false,
      sortable: false,
      headerName: "",
      cellClassName: (params) => {
        return "grid-cell";
      },
      flex: 1,
      renderCell: (params) => (
        <Stack
          direction="row"
          style={{
            width: "calc(100% - 16px)",
            height: "100%",
          }}
          className="Message-content-popup-cell"
        >
          <span style={{ width: "100%", paddingTop: "14px" }}>
            <Box sx={{ fontWeight: params.row.IsRead ? "medium" : "bold" }}>
              {" "}
              {params.row.Sender}
            </Box>
            <Stack direction="row">
              <Box sx={{ fontWeight: params.row.IsRead ? "medium" : "bold" }}>
                {params.row.ReferenceNumber ?? ""}
              </Box>
              <Stack
                className="item-tools"
                direction="row"
                spacing={4}
                style={{ marginLeft: "auto", marginRight: 10 }}
              >
                <FlipingImageButton
                  tooltip={
                    params.row.IsRead ? "Mark as Unread" : "Mark as Read"
                  }
                  src={markAsRead}
                  onClick={() => {
                    // heap.io
                    if (params?.row?.IsRead !== undefined && params.row.IsRead) {
                      window.heap.track("Messages - Unread Individual");
                    }

                    params &&
                      params.row &&
                      updateStatus(
                        [params.row.id],
                        params.row.IsRead
                          ? recordStatuses.unRead
                          : recordStatuses.read
                      );
                  }}
                  hoverSrc={MarkAsReadHover}
                />
                <FlipingImageButton
                  tooltip="Download PDF"
                  src={PDFDownload}
                  onClick={(x) => {
                    // heap.io
                    window.heap.track("Messages - Download (Row Icon)");

                    params &&
                      params.row &&
                      onReadPDF(
                        params.row.id,
                        params.row.EDITransactionId,
                        params.row.Type
                      );
                  }}
                  hoverSrc={PDFDownloadFilled}
                />
                <FlipingImageButton
                  tooltip={params.row.IsArchived ? "Unarchive" : "Archive"}
                  src={MessageArchive}
                  onClick={() => {
                    // heap.io
                    if (params?.row?.IsArchived !== undefined && !params.row.IsArchived) {
                      window.heap.track("Messages - Archive Individual");
                    }

                    params &&
                      params.row &&
                      updateStatus(
                        [params.row.id],
                        params.row.IsArchived
                          ? recordStatuses.unAchive
                          : recordStatuses.archive
                      );
                  }}
                  hoverSrc={MessageArchiveHover}
                />
                {!archive && (
                  <FlipingImageButton
                    tooltip={params.row.IsPinned ? "Unpin" : "Pin"}
                    src={PinInactive}
                    onClick={() => {
                      // heap.io
                      if (params?.row?.IsPinned !== undefined && !params.row.IsPinned) {
                        window.heap.track("Messages - Pin Individual");
                      }

                      if (!params.row.IsPinned && !allowPin()) {
                        dispatch(
                          createAlert({
                            status: "warning",
                            title: "Info",
                            alertType: "multi",
                            message:
                              "A maximum of 15 messages can be pinned at once.",
                            buttonLabel: "ok",
                          })
                        );
                        return;
                      }
                      params &&
                        params.row &&
                        updateStatus(
                          [params.row.id],
                          params.row.IsPinned
                            ? recordStatuses.unPin
                            : recordStatuses.pin
                        );
                    }}
                    hoverSrc={PinHover}
                  />
                )}
              </Stack>
            </Stack>
            <Stack direction="row">
              <Box
                sx={{
                  width: "350",
                  whiteSpace: "normal",
                  fontSize: 16,
                  wordWrap: "break-word",
                }}
              >
                {params.row.TypeDescription}
              </Box>
              <Box
                className="Receive-date"
                style={{ marginLeft: "auto", marginRight: 5 }}
              >
                {getDateString(params.row.ReceivedDate)}
              </Box>
            </Stack>
          </span>
        </Stack>
      ),
    },
  ];

  const allowPin = () => {
    if (rows.filter((x) => x.IsPinned).length >= max_pin) return false;
    return true;
  };

  const allowPinSelected = () => {
    var selectedIds = selectedModel.concat(selectedPinnedModel);

    const pinCount = rows.filter((x) => x.IsPinned && !x.IsArchived).length;

    const selected = rows.filter((x) => selectedIds.includes(x.id)).length;
    return pinCount + selected <= max_pin;
  };

  const prepFilters = () => {
    dispatch(setMessageFilterType({
        value: typeOptions,
        isInitValue: true // Used for heap.io tracking
    }));
    dispatch(
      setMessageFilterSender({
        value: connections.map((x) => {
          return { ...x, isChecked: false };
        }),
        isInitValue: true // Used for heap.io tracking
      })
    );
  };
  const schema = [
    {
      id: 0,
      label: "Message Type",
      type: FilterDropDownType.CheckboxList,
      cascading: true,
      includingAllCheckBox: true,
      childLabel: "Select Type",
      setValue: setMessageFilterType,
      readVal: selectMessageFilterType,
      labelKey: "label",
      uniqueKey: "key",
    },
    {
      id: 1,
      label: "From",
      type: FilterDropDownType.SearchableCheckboxList,
      cascading: true,
      includingAllCheckBox: true,
      childLabel: "Select Sender",
      setValue: setMessageFilterSender,
      readVal: selectMessageFilterSender,
      labelKey: "displayName",
      uniqueKey: "connectionId",
    },
    {
      id: 2,
      label: "Read",
      type: FilterDropDownType.Checkbox,
      cascading: false,
      setValue: setMessageFilterRead,
      readVal: selectMessageFilterRead,
    },
    {
      id: 3,
      label: "UnRead",
      type: FilterDropDownType.Checkbox,
      cascading: false,
      setValue: setMessageFilterUnread,
      readVal: selectMessageFilterUnread,
    },
  ];

  const getDateString = (date) => {
    if (!date) return "";

    if (typeof date === "string") {
      date = new Date(date);
    }
    if (!(date instanceof Date)) return "";
    return dayjs(date).format("YYYY.MM.DD");
  };
  const getMessages = (resetCache = false) => {
    const params = prepareGetProperties({ resetCache: resetCache });
    if (resetCache) {
      setIsDataLoaded(false);
    }
    getMessagesFromServer(params);
  };

  const getSenderFilter = (args) => {
    let senders = args && args.sender;
    if (!senders) {
      senders = senderFilter;
    }
    return senders
      ? JSON.stringify(
          senders.filter((x) => x.isChecked).map((x) => x.ConnectionId)
        )
      : "";
  };

  const getTypeFilter = (args) => {
    let types = args && args.type;
    if (!types) {
      types = typeFilter;
    }

    return types
      ? JSON.stringify(types.filter((x) => x.isChecked).map((x) => x.key))
      : "";
  };

  const prepareGetProperties = (args) => {
    const params = {
      senderFilterJson: getSenderFilter(args),
      typeFilterJson: getTypeFilter(args),
      read: args.read ? args.read : readFilter ?? false,
      unread: args.unread ? args.unread : unreadFilter ?? false,
      pinned: args.pinned ? args.pinned : pinnedFilter ?? false,
      startDate: args.startDate ?? dates[0],
      endDate: args.endDate ?? dates[1],
      resetCache: args.resetCache ?? false,
      referenceNumber: args.reference ?? referenceFilter,
      showArchived: true,
    };
    return params;
  };

  const getMessagesFromServer = (params) => {
    axios
      .get("/message/filterMessages", {
        params: params,
      })
      .then((response) => {
        setRows(response.data);
        selectFirstItem(response.data);
        setIsDataLoaded(true);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  };

  const selectFirstItem = (responseData) => {
    if (currentSelectedId && currentLoadedId !== "") return;
    const currentRows =
      responseData &&
      responseData.length &&
      responseData.filter((x) => x.IsArchived == archive);
    if (currentRows && currentRows.length) {
      const firstRow = currentRows[0];
      const newModel = [firstRow.id];
      setSelectedMessage(firstRow);
      if (archive) {
        setSelectedModel(newModel);
      } else {
        if (firstRow.IsPinned) {
          setSelectedPinnedModel(newModel);
          setSelectedModel([]);
        } else {
          setSelectedModel(newModel);
          setSelectedPinnedModel([]);
        }
      }
    }
  };

  const setDateFilterFromDate = (startDate, endDate) => {
    if (!startDate || !endDate) {
      return;
    }
      dispatch(setMessagesDateFilter({
        startDate: startDate,
        endDate: endDate,
        source: source ? source : "user",
      }));
    };

  const debouncedGetMessages = useCallback(
    _.debounce(getMessagesFromServer, 1000),
    []
  );

  //useCallback persists the debounced function
    const debouncedSetDateFilter = useCallback(
      _.debounce(setDateFilterFromDate, 1000),
      [source]
    );

  useEffect(() => {
    //delay when making first date selection
    const params = prepareGetProperties({
      startDate: dates[0],
      endDate: dates[1],
    });
    debouncedSetDateFilter(dates[0], dates[1]);
    debouncedGetMessages(params);
  }, [dates[0]]);

  useEffect(() => {
    //cancel delay and trigger backend call immediately (flush) after second date selection

    const params = prepareGetProperties({
      startDate: dates[0],
      endDate: dates[1],
    });
    debouncedSetDateFilter(dates[0], dates[1]);
    debouncedSetDateFilter.flush();
    debouncedGetMessages(params);
  }, [dates[1]]);

  useEffect(() => {
    const params = prepareGetProperties({
      sender: senderFilter,
      type: typeFilter,
      read: readFilter,
      unread: unreadFilter,
      pinned: pinnedFilter,
    });
    debouncedGetMessages(params);
  }, [typeFilter, senderFilter, readFilter, unreadFilter, pinnedFilter]);

  const updateSelectionStatus = (status) => {
    const ids = selectedModel.concat(selectedPinnedModel);
    const action = getRecordStatuses(status);

    if (ids.length > 0) {
      if (action) {
        updateStatus(ids, action);
      }
    } else {
      dispatch(
        createAlert({
          status: "Warning",
          alertType: "result",
          message: "Please select messages first!",
          buttonLabel: "Close",
        })
      );
    }
  };

  const getRecordStatuses = (action) => {
    if (action === recordStatuses.read || action === recordStatuses.unRead) {
      if (!anySelected("IsRead")) {
        return recordStatuses.read;
      }
      return recordStatuses.unRead;
    }
    if (
      action === recordStatuses.archive ||
      action === recordStatuses.unAchive
    ) {
      if (!anySelected("IsArchived")) {
        return recordStatuses.archive;
      }
      return recordStatuses.unAchive;
    }
    if (action === recordStatuses.pin || action === recordStatuses.unPin) {
      if (!anySelected("IsPinned")) {
        if (allowPinSelected()) {
          return recordStatuses.pin;
        } else {
          dispatch({
            status: "Warning",
            alertType: "result",
            message: "Cannot pin more messages!",
            buttonLabel: "Close",
          });
          return null;
        }
      }
      return recordStatuses.unPin;
    }
  };

  const anySelected = (status) => {
    var selectedIds = selectedModel.concat(selectedPinnedModel);
    return rows
      .filter((x) => selectedIds.includes(x.id))
      .some((m) => m[status]);
  };

  const updateStatus = (messageIds, action) => {
    if (messageIds && messageIds.length > 0) {
      const payload = {
        params: {
          idString: JSON.stringify(messageIds),
          action: action,
        },
      };
      axios
        .put("/message/updateStatus", null, payload)
        .then((response) => {
          getMessages(true);
          dispatch(
            createAlert({
              status: "Success",
              alertType: "result",
              message: response.data,
              buttonLabel: "Close",
            })
          );
        })
        .catch((error) =>
          dispatch(
            createAlert({
              status: "Error",
              alertType: "result",
              message: error.data,
              buttonLabel: "Close",
            })
          )
        );
    } else {
      dispatch({
        status: "Warning",
        alertType: "result",
        message: "Please select some messages first!",
        buttonLabel: "Close",
      });
    }
  };

  const onLoadMultiplePDF = () => {
    const fileName = `report_${Date.now()}.zip`;
    const allIds = selectedModel.concat(selectedPinnedModel);
    if (allIds && allIds.length) {
      const idString = JSON.stringify(allIds);
      axios
        .get("/message/loadMultiplePDFFiles", {
          params: { idString: idString },
          responseType: "arraybuffer",
        })
        .then((response) => {
          const blob = new Blob([response.data], { type: "application/zip" });
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", fileName);
          document.body.appendChild(link);
          link.click();
          getMessages(true);
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
        });

      getMessages(true);
    } else {
      dispatch(
        createAlert({
          status: "Warning",
          alertType: "result",
          message: "Please select some messages first!",
          buttonLabel: "Close",
        })
      );
    }
  };

  const onReadPDF = (messageId, eDITransactionId, fileType) => {
    let fileName = `report_${
      fileType == 0 ? fileType.toString() : fileType.toString().substring(1, 4)
    }_${Date.now()}.pdf`; // unique file name for all the reports.
    axios
      .get("/message/loadPDF", {
        params: { messageId: messageId, eDITransactionId: eDITransactionId },
        responseType: "arraybuffer",
      })
      .then((response) => {
        const blob = new Blob([response.data], { type: "application/pdf" });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.style.display = "none";
        link.setAttribute("download", fileName);
        document.body.appendChild(link);
        link.click();
        getMessages(true);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });

    getMessages(true);
  };

  const loadFileContent = (messageId) => {
    if (messageId === currentSelectedId) return;
    setSelectedMessage(rows.filter((m) => m.id === messageId)[0]);
    setCurrentSelectedId(messageId);
    axios
      .get("/message/fileContent", {
        params: { messageId: messageId },
      })
      .then((response) => {
        setCurrentLoadedId(messageId);
        setFileContent(response.data);
        const newRows = rows.map((x) => {
          if (x.id === messageId) return { ...x, IsRead: true };
          return x;
        });
        setRows(newRows);

        //file content is loaded for the first message already
        if (isInitialMessagesLoad) {
          setIsInitialMessagesLoad(false);
        }
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  };

  const handleTextChange = (event, data) => {
    const referenceNumber = event.target.value;
    setReferenceFilter(event.target.value);
    const params = prepareGetProperties({ reference: referenceNumber });
    debouncedGetMessages(params);
  };

  return (
    <Box
      className="message-content-popup"
      sx={{ display: "block", flexDirection: "column" }}
    >
      <Box style={{ display: "flex", paddingBottom: 40 }}>
        <CustomFilterDropdown schemas={schema} />
        <TextField
          placeholder="Search by Sender Name, Reference Number and Type"
          value={referenceFilter}
          onChange={handleTextChange}
          sx={{
            width: "562px",
            paddingLeft: "10px",
            "&.MuiFormControl-root .MuiInputBase-root": {
              borderRadius: "5px",
            },
          }}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon style={{ color: "var(--text-icon-regular)" }} />
              </InputAdornment>
            ),
          }}
        />

        <Stack
          display={
            selectedModel.length || selectedPinnedModel.length ? "flex" : "none"
          }
          direction="row"
          divider={<Divider orientation="vertical" flexItem />}
          className="batch-actions"
          sx={{ width: 100 }}
        >
          <Button onClick={() => {
              onLoadMultiplePDF();

              // heap.io
              window.heap.track("Messages - Bulk Download");
          }}>Download</Button>

          {!archive && (
            <Button onClick={() => {
                updateSelectionStatus(recordStatuses.pin);

                // heap.io
                window.heap.track("Messages - Bulk Pin");
            }}>
              Pin
            </Button>
          )}
          {!archive && (
            <Button
              onClick={() => {
                  updateSelectionStatus(recordStatuses.unRead);

                  // heap.io
                  window.heap.track("Messages - Bulk Unread");
              }}
            >
              Unread
            </Button>
          )}

          <Button
            onClick={() => {
                updateSelectionStatus(recordStatuses.archive);

                // heap.io
                if (!archive) {
                    window.heap.track("Messages - Bulk Archive");
                }
            }}
            style={{ color: "var(--secondary-1)" }}
          >
            {archive ? "Unarchive" : "Archive"}
          </Button>
        </Stack>

        <div
          className="message-content-datepicker"
          style={{ display: "flex", marginLeft: "auto", marginRight: 25 }}
        >
          <CustomDatePicker
            dates={dates}
            onApply={() => {}} // onApply cannot be null.
            setDates={setDates}
            customZIndex={1500}
            heapIOParentPage="Messages"
            preferenceKey={messagesDateFilterKey}
          />
        </div>
      </Box>
      <Box
        className="content-box"
        sx={{ display: "flex", flexDirection: "row", minHeight: "500px" }}
      >
        <Box sx={{ width: "45%" }}>
          <Box
            display={archive ? "none" : "block"}
            sx={{
              borderRadius: 5,
              backgroundColor: "white",
              padding: 5,
              marginBottom: 5,
              border: "1.5px solid var(--grey-lowlight)",
            }}
          >
            <div
              style={{
                fontSize: "1.5em",
                fontWeight: "bold",
                paddingBottom: "0.8em",
              }}
            >
              Pinned Messages
            </div>
            <ShepDataGridPro
              isDataLoaded={isDataLoaded}
              secondsToStall={1.5}
              autoHeight={false}
              rowHeight={130}
              disableColumnMenu={true}
              hideFooter={true}
              checkboxSelection={true}
              disableMultipleSelection={false}
              disableColumnReorder={true}
              rows={rows.filter(
                (item) => item.IsPinned === true && !archive && !item.IsArchived
              )}
              columns={columns}
              rowSelectionModel={selectedPinnedModel}
              onRowSelectionModelChange={(newModel) => {
                // heap.io: Trigger when selecting a pinned message
                if (selectedPinnedModel.length < newModel.length) {
                    window.heap.track("Messages - Select Pinned Message");
                }

                setSelectedPinnedModel(newModel);
              }}
              slots={{
                baseCheckbox: ShepCheckbox,
                pagination: ShepPagination,
              }}
              initialState={{
                pagination: { paginationModel: { pageSize: 10 } },
              }}
              sx={dataGridSx}
            />
          </Box>
          <Box sx={{ borderRadius: 5, backgroundColor: "white", padding: 5 }}>
            <div
              style={{
                fontSize: "1.5em",
                fontWeight: "bold",
                paddingBottom: "0.8em",
              }}
            >
              {archive ? "Archived Messages" : "All Messages"}
            </div>
            <Box>
              <ShepDataGridPro
                isDataLoaded={isDataLoaded}
                secondsToStall={1}
                autoHeight={false}
                rowHeight={105}
                disableColumnMenu={true}
                hideFooter={false}
                pagination
                checkboxSelection={true}
                disableMultipleSelection={false}
                disableColumnReorder={true}
                rowSelectionModel={selectedModel}
                onRowSelectionModelChange={(newModel) => {
                  // heap.io: Trigger when selecting a message
                  if (!archive && selectedModel.length < newModel.length) {
                    window.heap.track("Messages - Select Unpinned Message");
                  }

                  setSelectedModel(newModel);
                }}
                rows={rows.filter(
                  (item) =>
                    (item.IsPinned === false && !archive && !item.IsArchived) ||
                    (item.IsArchived && archive)
                )}
                columns={columns}
                slots={{
                  baseCheckbox: ShepCheckbox,
                  pagination: (props) => (
                    <ShepPagination
                      {...props}
                      showRowCount={false}
                      pageOptions={[15]}
                    />
                  ),
                }}
                initialState={{
                  pagination: {
                    paginationModel: { pageSize: 15, page: 0 },
                  },
                }}
                sx={dataGridSx}
              />
            </Box>
          </Box>
        </Box>
        <Box
          className="flex column justify-left"
          sx={{
            flex: "auto",
            borderRadius: 5,
            backgroundColor: "white",
            marginLeft: 3,
            marginRight: 0,
            padding: 3,
          }}
        >
          <Container style={{ display: "flex" }}>
            <img
              className="MessageOpen"
              src={MessagesOpen}
              style={{
                width: 40,
                marginRight: 20,

                marginBottom: 50,
              }}
              sx={{
                "&:hover fieldset": {
                  marginBottom: 130,
                },
              }}
            />
            <Box flex="auto" className="Message-content-popup-cell">
              <Box sx={{ fontWeight: "bold", marginBottom: 1 }}>
                {selectedMessage ? selectedMessage.Sender : ""}
              </Box>
              <Box sx={{ fontSize: 16 }}>
                {selectedMessage ? selectedMessage.ReferenceNumber ?? "" : ""}
              </Box>
              <Box sx={{ fontSize: 16, maxWidth: 450 }}>
                {selectedMessage ? selectedMessage.TypeDescription : ""}
              </Box>
            </Box>
            <Stack direction={"column"} flex="auto">
              <img
                src={PinHover}
                height={16}
                alt="pinned"
                style={{
                  marginLeft: "auto",
                  marginBottom: 10,
                  display:
                    selectedMessage && selectedMessage.IsPinned && !archive
                      ? "flex"
                      : "none",
                }}
              />
              <FlipingImageButton
                style={{ marginLeft: "auto" }}
                tooltip="Download PDF"
                src={PDFDownload}
                hoverSrc={PDFDownloadFilled}
                height={36}
                onClick={(x) => {
                  // heap.io
                  window.heap.track("Messages - Download (Full Display Icon)");

                  if (selectedMessage) {
                    onReadPDF(
                      selectedMessage.id,
                      selectedMessage.EDITransactionId,
                      selectedMessage.Type
                    );
                  } else {
                    dispatch(
                      createAlert({
                        status: "Warning",
                        alertType: "result",
                        message: "Please select some messages first!",
                        buttonLabel: "Close",
                      })
                    );
                  }
                }}
              />
              <Typography
                className="Receive-date"
                style={{ marginLeft: "auto" }}
              >
                {getDateString(selectedMessage?.ReceivedDate)}
              </Typography>
            </Stack>
          </Container>
          <Divider flexItem />
          <textarea
            style={{
              marginTop: "15px",
              width: "100%",
              height: "600px",
              border: "none",
              outline: "none",
              background: "white",
              fontSize: 16,
              whiteSpace: "pre",
              overflowWrap: "normal",
              overflowX: "scroll",
            }}
            value={fileContent}
            disabled
          ></textarea>
        </Box>
      </Box>
    </Box>
  );
};

export default MessageContent;
